import { AssetIdFormatterUtil } from 'src/app/utils/asset-id-utils';
import { bnbAddress, btcAddress, ethAddress, polyAddress } from 'src/environments/environment';
import { Asset } from '../components/models/asset.model';

export function formatAssetName(asset: string): string {
  if (asset.includes('BTC')) {
    return 'Bitcoin';
  }
  if (asset === 'ETH.ETH') {
    return 'Ether';
  }
  if (asset.includes('USDC')) {
    return 'USD Coin';
  }
  if (asset.includes('USDT')) {
    return 'Tether';
  }
  if (asset.includes('POL')) {
    return 'Polygon';
  }
  return '';
}

export function formatNetworkName(network: string): string {
  switch (network) {
    case 'ETH':
      return 'Ethereum';
    case 'MATIC':
      return 'Polygon';
    case 'BTC':
      return 'Bitcoin';
    case 'TRC':
      return 'TRON';
    default:
      return '';
  }
}

export function getFormatedNetworkName(networkId: string) {
  return `${formatNetworkName(networkId).toLowerCase()}Network`;
}

export function getScanAddress(transactionId: string, transactionAsset: string): string {
  if (transactionAsset.startsWith('BTC.')) {
    return btcAddress + 'tx/' + transactionId.trim();
  }
  if (transactionAsset.startsWith('ETH.')) {
    return ethAddress + 'tx/' + transactionId.trim();
  }
  if (transactionAsset.startsWith('MATIC.')) {
    return polyAddress + 'tx/' + transactionId.trim();
  }
  if (transactionAsset.startsWith('BEP.')) {
    return bnbAddress + 'tx/' + transactionId.trim();
  }
  return '';
}

export function getNetwork(selectedAsset: string, network: string): string {
  if (selectedAsset === 'USDT' || selectedAsset === 'USDC') {
    if (network === 'MATIC') {
      return 'MATIC';
    }
    if (network === 'ETH') {
      return 'ETH';
    }
  }
  return '';
}

export function getAssetAndNetworkId(
  selectedAsset: string,
  network: string,
  assetIdFormatterUtil: AssetIdFormatterUtil,
): string {
  if (selectedAsset === 'USDC' || selectedAsset === 'USDT') {
    return `${network}.${selectedAsset}`;
  }

  return assetIdFormatterUtil.formatBlockchainAssetId(selectedAsset);
}

export function isFiatAsset(asset: string): boolean {
  return asset !== 'BTC' && asset !== 'ETH';
}

export function categorizeAssets(
  assets: Asset[],
  receiverAcceptedAssets: Asset[],
  requestParams: any,
  fiatAssets: Asset[],
  cryptoAssets: Asset[],
): void {
  assets.forEach((asset: Asset) => {
    const userAcceptCurrentAsset = receiverAcceptedAssets.some((acceptedAsset) => acceptedAsset.id === asset.id);

    if (!requestParams && receiverAcceptedAssets.length > 0) {
      if (asset.isFiat) {
        if (userAcceptCurrentAsset) fiatAssets.push(asset);
      } else {
        if (!asset.id.includes('MATIC') && !asset.id.includes('TRC') && userAcceptCurrentAsset) {
          cryptoAssets.push(asset);
        }
      }
    } else {
      if (asset.isFiat) {
        fiatAssets.push(asset);
      } else {
        if (!asset.id.includes('MATIC') && !asset.id.includes('TRC')) {
          cryptoAssets.push(asset);
        }
      }
    }
  });
}

export function categorizeAssetsForPaymentRequests(
  assets: Asset[],
  receiverAcceptedAssets: Asset[],
  fiatAssets: Asset[],
  cryptoAssets: Asset[],
): void {
  assets.forEach((asset: Asset) => {
    const userAcceptCurrentAsset = receiverAcceptedAssets.some((acceptedAsset) => acceptedAsset.id === asset.id);

    if (receiverAcceptedAssets.length > 0) {
      if (asset.isFiat && userAcceptCurrentAsset) {
        fiatAssets.push(asset);
      } else if ((!asset.id.includes('MATIC') || asset.assetTicker === 'POL') && userAcceptCurrentAsset) {
        cryptoAssets.push(asset);
      }
    } else {
      if (asset.isFiat) {
        fiatAssets.push(asset);
      } else if (!asset.id.includes('MATIC')) {
        cryptoAssets.push(asset);
      }
    }
  });
}

export function getEnabledNetworks(receiverConnections: any[], selectedAsset: string): string[] {
  const enabledNetworks: string[] = [];

  receiverConnections.forEach((connection) => {
    if (connection.assetTicker === selectedAsset) {
      if (connection.id.includes('ETH') && !enabledNetworks.includes('ETH')) {
        enabledNetworks.push('ETH');
      } else if (connection.id.includes('MATIC') && !enabledNetworks.includes('MATIC')) {
        enabledNetworks.push('MATIC');
      } else if (!enabledNetworks.includes('TRC')) {
        enabledNetworks.push('TRC');
      }
    }
  });

  return enabledNetworks;
}
